function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import isEmpty from 'lodash/isEmpty';
import includes from 'lodash/includes';
import { mapState } from 'vuex';
export default {
  mounted: function mounted() {
    if (this.$ncsConfig.queryLinks.enabled) {
      var querystring = location.search.substring(1);
      this.$ncsConfig.queryLinks.parseQuery(querystring, this.$store);
    }
  },
  computed: _objectSpread({}, mapState({
    resultType: function resultType(s) {
      return s.api.resultType;
    },
    query: function query(s) {
      return s.api.query;
    },
    result: function result(s) {
      return s.api.result;
    }
  })),
  watch: {
    result: function result() {
      if (this.$ncsConfig.queryLinks.enabled && this.result) {
        var snapshot = this.$store.getters["history/snapshot"];
        snapshot.api.result = undefined; // We dont want the full result in the url

        var page = window.location.href.split('?')[0];
        var querystring = this.$ncsConfig.queryLinks.stringifyQuery(snapshot, this.$store);
        window.history.replaceState({}, '', page + '?' + querystring);
      }
    }
  }
};